const ZDANIA130 = [
  {
    name: "Słówka (PL/EN) 2026 luty",
    lang: "en",
    zdania: [
      { pl: "piaszczysta/kamienista plaża", de: "sandy/stone beach" },
      { pl: "powyżej/poniżej poziomu morza", de: "above/below sea level" },
      { pl: "wybrzeże, brzeg", de: "coast" },
      { pl: "rafa koralowa", de: "coral reef" },
      { pl: "pustynia", de: "desert" },
      { pl: "pole", de: "field" },
      { pl: "las", de: "forest" },
      { pl: "wzgórze", de: "hill" },
      { pl: "wyspa", de: "island" },
      { pl: "jezioro", de: "lake" },
      { pl: "krajobraz", de: "landscape" },
      { pl: "góra", de: "mountain" },
      { pl: "ścieżka", de: "path" },
      { pl: "las deszczowy", de: "rainforest" },
      { pl: "szczyt", de: "summit/top" },
      { pl: "dolina", de: "valley" },
      { pl: "wulkan", de: "volcano" },
      { pl: "wodospad", de: "waterfall" },
      { pl: "fala", de: "wave" },

      { pl: "środkowa", de: "central" },
      { pl: "wschód/wschodni", de: "east/eastern" },
      { pl: "północ/północny", de: "north/northern" },
      { pl: "południe/południowy", de: "south/southern" },
      { pl: "zachód/zachodni", de: "west/western" },

      { pl: "powyżej/poniżej zera", de: "above/below zero" },
      { pl: "wiać", de: "blow" },
      { pl: "chłodny", de: "chilly/cool" },
      { pl: "bezchmurny, rozpogodzić się", de: "clear" },
      { pl: "bezchmurne niebo", de: "clear sky" },
      { pl: "chmura/pochmurny", de: "cloud/cloudy" },
      { pl: "zimny", de: "cold" },
      { pl: "stopnie Celsjusza", de: "degrees Celsius" },
      { pl: "suchy", de: "dry" },
      { pl: "mgła/mglisty", de: "fog/foggy" },
      { pl: "lodowaty", de: "freezing" },
      { pl: "mróz/mroźny", de: "frost/frosty" },
      { pl: "gorący", de: "hot" },
      { pl: "lód", de: "ice" },
      { pl: "oblodzony", de: "icy" },
      { pl: "błyskawica", de: "lightning" },
      { pl: "deszcz/padać", de: "rain" },
      { pl: "deszczowy", de: "rainy" },
      { pl: "sezon", de: "season" },
      { pl: "świecić", de: "shine" },
      { pl: "śnieg/padać śnieg", de: "snow" },
      { pl: "śnieżny", de: "snowy" },
      { pl: "burza/burzowy", de: "storm/stormy" },
      { pl: "słońce/słoneczny", de: "sun/sunny" },
      { pl: "światło słoneczne", de: "sunshine" },
      { pl: "grzmot", de: "thunder" },
      { pl: "ciepły", de: "warm" },
      { pl: "pogoda", de: "weather" },
      { pl: "prognoza pogody", de: "weather forecast" },
      { pl: "mokry", de: "wet" },
      { pl: "wiatr/wietrzny", de: "wind/windy" },

      { pl: "płaz", de: "amphibian" },
      { pl: "mrówka", de: "ant" },
      { pl: "mrowisko", de: "anthill" },
      { pl: "akwarium", de: "aquarium" },
      { pl: "szczekać", de: "bark" },
      { pl: "nietoperz", de: "bat" },
      { pl: "niedźwiedź polarny/brunatny", de: "polar/brown bear" },
      { pl: "pszczoła", de: "bee" },
      { pl: "nora", de: "burrow" },
      { pl: "klatka", de: "cage" },
      { pl: "wielbłąd", de: "camel" },
      { pl: "gepard", de: "cheetah" },
      { pl: "szympans", de: "chimpanzee" },
      { pl: "jeleń", de: "deer" },
      { pl: "delfin", de: "dolphin" },
      { pl: "orzeł", de: "eagle" },
      { pl: "łoś", de: "elk" },
      { pl: "karmić", de: "feed" },
      { pl: "latać", de: "fly" },
      { pl: "panda wielka", de: "giant panda" },
      { pl: "żyrafa", de: "giraffe" },
      { pl: "świstak", de: "groundhog" },
      { pl: "chomik", de: "hamster" },
      { pl: "zając", de: "hare" },
      { pl: "jeż", de: "hedgehog" },
      { pl: "owad", de: "insect" },
      { pl: "kangur", de: "kangaroo" },
      { pl: "kociak", de: "kitten" },
      { pl: "ssak", de: "mammal" },
      { pl: "komar", de: "mosquito" },
      { pl: "pingwin", de: "penguin" },
      { pl: "zwierzę domowe", de: "pet" },
      { pl: "gołąb", de: "pigeon" },
      { pl: "gad", de: "reptile" },
      { pl: "nosorożec", de: "rhino/rhinoceros" },
      { pl: "foka", de: "seal" },
      { pl: "rekin", de: "shark" },
      { pl: "owca", de: "sheep" },
      { pl: "ślimak", de: "snail" },
      { pl: "gatunek", de: "species" },
      { pl: "wiewiórka", de: "squirrel" },
      { pl: "bocian", de: "stork" },
      { pl: "żółw lądowy", de: "tortoise" },
      { pl: "tresować", de: "train" },
      { pl: "żółw wodny", de: "turtle" },
      { pl: "merdać", de: "wag" },
      { pl: "wieloryb", de: "whale" },
      { pl: "gwizdać", de: "whistle" },
      { pl: "zwierzę dzikie/gospodarcze", de: "wild/farm animal" },

      { pl: "dziób", de: "beak" },
      { pl: "pazur", de: "claw" },
      { pl: "pióro", de: "feather" },
      { pl: "płetwa", de: "fin" },
      { pl: "futro", de: "fur" },
      { pl: "kopyto", de: "hoof" },
      { pl: "róg", de: "horn" },
      { pl: "skorupa", de: "shell" },
      { pl: "ogon", de: "tail" },
      { pl: "kieł", de: "tusk" },
      { pl: "skrzydło", de: "wing" },

      // ⭐ DODANE BRAKUJĄCE

      { pl: "gałąź", de: "branch" },
      { pl: "krzak", de: "bush" },
      { pl: "liść/liście", de: "leaf/leaves" },
      { pl: "roślina", de: "plant" },
      { pl: "korzeń", de: "root" },
      { pl: "nasiono", de: "seed" },
      { pl: "łodyga", de: "stem" },
      { pl: "pień", de: "trunk" },

      { pl: "popiół", de: "ash" },
      { pl: "lawina", de: "avalanche" },
      { pl: "katastrofa", de: "catastrophe" },
      { pl: "niszczyć", de: "destroy" },
      { pl: "susza", de: "drought" },
      { pl: "utonąć", de: "drown" },
      { pl: "trzęsienie ziemi", de: "earthquake" },
      { pl: "zestaw ratowniczy", de: "emergency kit" },
      { pl: "wybuchać", de: "erupt" },
      { pl: "ewakuować", de: "evacuate" },
      { pl: "pożar", de: "fire" },
      { pl: "gaśnica", de: "fire extinguisher" },
      { pl: "powódź", de: "flood" },
      { pl: "huragan", de: "hurricane" },
      { pl: "klęska żywiołowa", de: "natural disaster" },
      { pl: "trząść się", de: "shake" },
      { pl: "osoba która przetrwała", de: "survivor" },
      { pl: "tajfun", de: "typhoon" },
      { pl: "wybuch wulkanu", de: "volcanic eruption" },

      { pl: "kwaśny deszcz", de: "acid rain" },
      { pl: "zanieczyszczenie powietrza/wody", de: "air/water pollution" },
      { pl: "akumulator", de: "battery" },
      { pl: "dwutlenek węgla", de: "carbon dioxide" },
      { pl: "spowodować", de: "cause" },
      { pl: "chemikalia", de: "chemicals" },
      { pl: "zmiana klimatu", de: "climate change" },
      { pl: "spadać, zmniejszać się", de: "drop" },
      { pl: "śmiecić", de: "drop litter" },
      { pl: "zagrożone gatunki", de: "endangered species" },
      { pl: "środowisko", de: "environment" },
      { pl: "wymarły", de: "extinct" },
      { pl: "spaliny", de: "fumes" },
      { pl: "globalne ocieplenie", de: "global warming" },
      { pl: "ekologiczny", de: "green/eco-friendly" },
      { pl: "efekt cieplarniany", de: "greenhouse effect" },
      { pl: "siedlisko", de: "habitat" },
      { pl: "szkodliwe substancje", de: "harmful substances" },
      { pl: "polować", de: "hunt" },
      { pl: "kłusownictwo", de: "illegal hunting" },
      { pl: "zagrożony wyginięciem", de: "in danger of extinction" },
      { pl: "na wolności", de: "in the wild" },
      { pl: "wysypisko śmieci", de: "landfill" },
      { pl: "śmieci", de: "litter/rubbish/waste" },
      { pl: "topnieć", de: "melt" },
      { pl: "park narodowy", de: "national park" },
      { pl: "kłusować", de: "poach" },
      { pl: "zbierać śmieci", de: "pick up litter" },
      { pl: "sadzić drzewa", de: "plant trees" },
      { pl: "zanieczyszczenia", de: "pollution" },
      { pl: "chronić/niszczyć środowisko", de: "protect/damage the environment" },
      { pl: "pod ochroną", de: "under protection" },
      { pl: "segregować śmieci", de: "recycle rubbish" },
      { pl: "pojemnik na segregację", de: "recycling bank" },
      { pl: "energia odnawialna", de: "renewable energy" },
      { pl: "kosz na śmieci", de: "rubbish bin" },
      { pl: "rezerwat przyrody", de: "wildlife sanctuary" },
      { pl: "oszczędzać energię/wodę", de: "save energy/water" },
      { pl: "energia słoneczna/wiatrowa", de: "solar/wind power" },
      { pl: "źródło energii", de: "source of energy" },
      { pl: "wyrzucać śmieci", de: "throw away rubbish" },
      { pl: "marnować", de: "waste" },
      { pl: "dzika przyroda", de: "wildlife" },

      { pl: "schronisko dla zwierząt", de: "animal shelter" },
      { pl: "w efekcie", de: "as a result" },
      { pl: "składać się", de: "consist of" },
      { pl: "trzymać psa na smyczy", de: "keep a dog on a leash" }
    ]
  }
];

export { ZDANIA130 };
